import { render, staticRenderFns } from "./step-2.vue?vue&type=template&id=d1431870&scoped=true&"
import script from "./step-2.vue?vue&type=script&lang=js&"
export * from "./step-2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1431870",
  null
  
)

export default component.exports